import React from "react";
import { useSelector } from "react-redux";
import { Grid, FormControl, Typography } from "@mui/material";
import { ReadOnlyField } from "./ReadOnlyField";

export const DataFiscal = () => {
  const { fiscalData, bankReference } = useSelector(({ erpEquivalencies }) => erpEquivalencies);
  const address = fiscalData?.address;
  const addressAll = address ?
    `${address?.street} ${address?.extNumber} ${address?.intNumber ? address?.intNumber : ""} ${address?.colony} ${address?.postalCode} ${address?.municipality} ${address?.state}`
    : "";
  return (
    <FormControl fullWidth >
      <Grid container spacing={1} style={{ paddingRight: 0 }}>
        <ReadOnlyField label="Número de Cliente" value={fiscalData?.oracleNumber} />
        <ReadOnlyField label="Código Gn4" value={fiscalData?.code} />
        <ReadOnlyField label="Nombre Cliente" value={fiscalData?.name} />
        <ReadOnlyField label="RFC" value={fiscalData?.rfc} />
        <ReadOnlyField label="Regimen" value={fiscalData?.regime} />
        <ReadOnlyField label="Dirección" value={addressAll} multiline rows={2} />
        {bankReference.map((bank, index) => (
          <React.Fragment key={index}>
            <Grid item xs={12} sm={12}>
              <Typography variant="subtitle1" gutterBottom sx={{ textTransform: 'none' }}>
                Referencia bancaria {index + 1}
              </Typography>
            </Grid>
            <ReadOnlyField label="Banco" value={bank?.bankName} />
            <ReadOnlyField label="Sucursal" value={bank?.branch} sm={6} />
            <ReadOnlyField label="Cuenta" value={bank?.account} sm={6} />
            <ReadOnlyField label="CLABE" value={bank?.clabe} />
            <ReadOnlyField label="Referencia" value={bank?.reference} sm={6} />
            <ReadOnlyField label="Convenio" value={bank?.convenio} sm={6} />
          </React.Fragment>
        ))}
      </Grid>
    </FormControl>
  )
}
